import { render, staticRenderFns } from "./NetaEventDetailsMenuComponent.vue?vue&type=template&id=0eb2331f&scoped=true&"
import script from "./NetaEventDetailsMenuComponent.vue?vue&type=script&lang=js&"
export * from "./NetaEventDetailsMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaEventDetailsMenuComponent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NetaEventDetailsMenuComponent.vue?vue&type=style&index=1&id=0eb2331f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb2331f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eb2331f')) {
      api.createRecord('0eb2331f', component.options)
    } else {
      api.reload('0eb2331f', component.options)
    }
    module.hot.accept("./NetaEventDetailsMenuComponent.vue?vue&type=template&id=0eb2331f&scoped=true&", function () {
      api.rerender('0eb2331f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-event/NetaEventDetailsMenuComponent.vue"
export default component.exports